export const eventDistributionMessagesEn = {
  'dataExploration.eventDistribution.heading': 'Event distribution',
  'dataExploration.eventDistribution.heading.av': 'Record distribution',
};
